import React from 'react';
import Spacing from '@tamagoshi/core/Spacing';
import Navigation from '../Navigation';
import More from '../More';

import styles from './styles/index.module.scss';

const Links = () => (
  <div className={styles.desktopBlock}>
    <Spacing type="mb" size={48}>
      <div className={styles.linkSection}>
        <Navigation />
        <Spacing type="mt" size={48}>
          <More />
        </Spacing>
      </div>
    </Spacing>
  </div>
);

Links.displayName = 'Links';

export default Links;
